'use strict';
var parent = require('../../es/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/stable/object/assign.js
// module id = 491
// module chunks = 0